module.exports = __webpack_public_path__ + "img/default-avatar.4dbe9e94.jpg";